import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClearIcon from '@material-ui/icons/Clear';
import CancelIcon from '@material-ui/icons/Cancel';
import { BookUploadContext } from './context';
import axios from 'axios';
import { API_HOST } from '../../consts';

const DivSelect = styled.div`
	display: flex;
	justify-content: start;
	align-items: center;
	padding-left: 10px;
	height: 31px;
	border-radius: 10px;
	border: 1px solid #DED8D8;
	font: Quicksand;
	font-size: 12px;
	background: #F7F7F7;
	color: #383838;
	width: 500px;
	&:hover{
		box-shadow: 0.5px 0.5px #DED8D8;
	}
`;

const DivOptionFather = styled.div`
	display: flex;
	flex-direction: column;
	position: absolute;
	margin-top: 41px;
	height: 200px;
	width: 500px;
	/* width: 100%; */
	border: 1px solid #DED8D8;
	background: white;
	overflow: auto;
	font: Quicksand;
	font-size: 12px;
	color: #333333;
	z-index: 1;
`;

const DivOption = styled.div`
	padding-left: 20px;
	gap: 5px;
	display: flex;
	justify-content: start;
	align-items: center;	
	/* height: 50px; */
	&:hover{
		background: #eff7ff;
	}
`;

const DivTarget = styled.div`
	display: flex;
	padding: 3px 5px 3px 5px;
	justify-content: start;
	align-items: center;
	margin-left: 4px;
	background: #D0E3F8;
	border-radius: 4px;
	font-size: 12px;
	color: #2466AF;
`;

const ButtonSelect = styled.div`
	width: 25px;
	font-size: 12px;
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	/* right: 460px; */
	color: rgba(0, 0, 0,0.5);
	border: transparent;
	background: transparent;
	cursor: pointer;
	&:hover{
		color: rgba(0, 0, 0);
	}
`;

const LabelSelect = styled.label`
	color: #333333;
	font-size: 14px;
	font-weight: bold;
	font-family: Quicksand;
	margin-bottom: 3px;
`;

const InputSelecCheckBox = ({ ...props }) => {
	const { data, handleDataChange, generalInfo } = useContext(BookUploadContext);
	const {
		label,
		options,
		col,
		placeholder,
		disabled,
		required,
		chapterId,
		...rest
	} = props;

	const [selectedOptions, setSelectedOptions] = useState([]);
	const [optionsApi, setOptionsApi] = useState([]);
	const [isVisible, setIsVisible] = useState(false);
	const [contextSender, setContextSender] = useState([]);
	const selectRef = useRef(null);

	const handleIsVisible = () => {
		setIsVisible(!isVisible);
	};

	const handleOption = (option) => {
		if (selectedOptions.includes(option)) {
			setSelectedOptions(selectedOptions.filter((item) => item !== option));
		} else {
			setSelectedOptions([...selectedOptions, option]);
		};
	};

	const handleRemove = (e, option) => {
		e.stopPropagation();
		setSelectedOptions(selectedOptions.filter((item) => item !== option));
	};

	useEffect(() => {
		if (disabled) {
			setSelectedOptions([])
			setOptionsApi([])
			setIsVisible(false);
		}
		else {
			// if (data[chapterId].skills) {
			// 	const fetchHabilidade = () => {
			// 		const chapterOptions = []
			// 		data[chapterId].skills.map((skill) => {
			// 			axios.get(`${API_HOST}/matriz_referencia/habilidade?area_conhecimento_id=${generalInfo.area_conhecimento_id}&search=${skill}`).then((response) => {
			// 				const nInfo = {
			// 					...response.data.results[0],
			// 					value: response.data.results[0].id,
			// 					label: response.data.results[0].cd_habilidade,
			// 				}
			// 				chapterOptions.push(nInfo);
			// 			});
			// 			setOptionsApi(chapterOptions)
			// 			setSelectedOptions(chapterOptions)
			// 		})
			// 	};
			// 	fetchHabilidade();
			// }
		}
	}, [options]);

	useEffect(() => {
		handleDataChange(chapterId, 'skills', selectedOptions)
	}, [selectedOptions])

	useEffect(() => {
		const handleOutsideClick = (event) => {
			if (selectRef.current && !selectRef.current.contains(event.target)) {
				setIsVisible(false);
			}
		};

		document.addEventListener('click', handleOutsideClick);
		return () => {
			document.removeEventListener('click', handleOutsideClick);
		};
	}, []);

	return (
		<div className={`${col} d-flex flex-column`} style={disabled ? { pointerEvents: "none", opacity: 0.6 } : {}} ref={selectRef}>
			<LabelSelect>{label}{required && <span style={{ color: "red" }}>*</span>}</LabelSelect>
			<DivSelect onClick={() => handleIsVisible()}>
				{selectedOptions.length == 0 ? (
					<>
						<div style={{ width: "100%", color: "#383838bf", fontSize: "11px" }}>
							<span>{placeholder}</span>
						</div>
					</>
				) : (
					selectedOptions.length <= 8 ? (
						<>
							{selectedOptions.map((option) => (
								<DivTarget key={option.id}>
									<span >{option.label} | <span style={{ cursor: "pointer" }} onClick={(e) => handleRemove(e, option)}><ClearIcon style={{ fontSize: "12px" }} /></span></span>
								</DivTarget>
							))}
							<ButtonSelect>
								{isVisible ? <CancelIcon style={{ fontSize: "12px" }} /> : <ArrowDropDownIcon />}
							</ButtonSelect>
						</>
					) : (
						<>
							{selectedOptions.slice(0, 8).map((option) => (
								<>
									<DivTarget key={option.id}>
										<span >{option.label} | <span style={{ cursor: "pointer" }} onClick={(e) => handleRemove(e, option)}><ClearIcon style={{ fontSize: "12px" }} /></span></span>
									</DivTarget>
								</>
							))}
							<DivTarget>
								<span>+{selectedOptions.length - 8}</span>
							</DivTarget>
							<ButtonSelect>
								{isVisible ? <CancelIcon style={{ fontSize: "12px" }} /> : <ArrowDropDownIcon />}
							</ButtonSelect>
						</>
					)
				)}
			</DivSelect>
			{isVisible && (optionsApi.length > 0 ? (<DivOptionFather>
				{optionsApi.map((option) => (
					<DivOption key={option.value}>
						<input
							style={{ fontSize: "13px", height: "35px" }}
							type="checkbox"
							value={option.value}
							checked={selectedOptions.includes(option)}
							onChange={() => handleOption(option)}
							{...rest}
						/>
						{option.label}
					</DivOption>
				))}
			</DivOptionFather>)
				: (<DivOptionFather style={{ height: "35px", paddingLeft: "10px", paddingTop: "5px" }}>
					<span style={{ fontSize: "13px", height: "35px", opacity: "60%" }}>Nenhum resultado encontrado</span>
				</DivOptionFather>)
			)}
		</div>
	);
};

export default InputSelecCheckBox;